/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemSettingDoubleModel model module.
 * @module model/SystemSettingDoubleModel
 * @version v1.0.0
 */
class SystemSettingDoubleModel {
    /**
     * Constructs a new <code>SystemSettingDoubleModel</code>.
     * @alias module:model/SystemSettingDoubleModel
     */
    constructor() { 
        
        SystemSettingDoubleModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemSettingDoubleModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemSettingDoubleModel} obj Optional instance to populate.
     * @return {module:model/SystemSettingDoubleModel} The populated <code>SystemSettingDoubleModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemSettingDoubleModel();

            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * number of data
 * @member {Number} data
 */
SystemSettingDoubleModel.prototype['data'] = undefined;






export default SystemSettingDoubleModel;

